module.exports = __webpack_public_path__ + "img/3ecf0b7.jpg";